import { tokens } from '../../tokens/underlyingTokens';
import type { VToken } from '../../types';

export const opBnbMainnet: VToken[] = [
  {
    chainId: 204,
    address: "0xED827b80Bd838192EA95002C01B5c6dA8354219a",
    decimals: 8,
    symbol: "vBTCB_Core",
    underlyingToken: tokens[204][2]!,
  },
  {
    chainId: 204,
    address: "0x509e81eF638D489936FA85BC58F52Df01190d26C",
    decimals: 8,
    symbol: "vETH_Core",
    underlyingToken: tokens[204][3]!,
  },
  {
    chainId: 204,
    address: "0xb7a01Ba126830692238521a1aA7E7A7509410b8e",
    decimals: 8,
    symbol: "vUSDT_Core",
    underlyingToken: tokens[204][4]!,
  },
  {
    chainId: 204,
    address: "0x53d11cB8A0e5320Cd7229C3acc80d1A0707F2672",
    decimals: 8,
    symbol: "vWBNB_Core",
    underlyingToken: tokens[204][6]!,
  },
  {
    chainId: 204,
    address: "0x13B492B8A03d072Bab5C54AC91Dba5b830a50917",
    decimals: 8,
    symbol: "vFDUSD_Core",
    underlyingToken: tokens[204][5]!,
  },
];
